<bspk-dialog [placement]="placement()" [width]="width()" [widthFull]="widthFull()"  [(open)]="open">
  <div data-bspk="modal">
    <div data-modal-header>
      <div bspk-txt="heading-h4" data-dialog-title [innerHTML]="header()">
      </div>
      <button
        aria-label="Close"
        bspk-button
        hideLabel
        icon="Close"
        variant="tertiary"
        (click)="open.set(false)"
      >
        Close
      </button>
    </div>
    <div data-modal-main>
      <ng-content />
    </div>
    @if (buttons().length > 0) {
      <div data-button-format="horizontal" data-modal-footer>
        @for (button of buttons(); track $index) {
          <button bspk-button size="small" width="hug" [variant]="button.variant" (click)="button.onClick($event)">{{button.label}}</button>
        }
      </div>
    }
  </div>
</bspk-dialog>
